//import './styles/fonts.css';
import './styles/index.css';
import 'swiper/css';

import './js/anims';
import './js/menu';
import './js/no-widows';
import './js/topbar';
import './js/smoothscroll';

if (document.querySelector("[data-accordion]")) {
  import('./js/accordion').then(({ initAccordion }) => {
    initAccordion();
  });
}

if (document.querySelector("[data-scroll-nav]")) {
  import('./js/scroll-nav').then(({ initScrollNav }) => {
    initScrollNav();
  });
}

if (document.querySelectorAll(".js-roller").length > 0) {
  import('./js/roller').then(({ initRoller }) => {
    initRoller();
  });
}

if (document.querySelectorAll(".js-simple-carousel").length > 0) {
  import('./js/swiper').then(({ initSwiper }) => {
    initSwiper();
  });
}

if (document.querySelector("#timeline")) {
  import('./js/timeline').then(({ initTimeline }) => {
    initTimeline();
  });
}